import React from "react";
import {motion} from 'framer-motion'
import '../CSS/Home.scss'
import {homeSpanRight, homeSpanLeft, homeSpanBot, homePage, spanAnim, socialAnim, socialVar, socialBot, socialLine} from '../Variants/homeVariants'
import {faAt} from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HomeSpan from "./HomeSpan";
import {Link} from "react-router-dom";

const Home = () => {
    let hello = ("Hello, ").split("");
    let jimmy = ("I'm Jimmy").split("");
    let dev = ("A Front End Developer").split("");
    let artist = ("And Artist!").split("");

    const MotionLink = motion(Link);

    const artContainer ={
        animate:{
            transition:{
                duration: 1.5,
                staggerChildren: 0.02,
                delayChildren: 2,
            }
        }
    }

    const projectLinkContainer = {
        initial: { opacity: 0 },
        animate: {
          opacity: 1,
          transition: {
            duration: .75,
            ease: "easeOut"
          }
        }
    }

    return(
        <motion.div className="home" >
            <motion.div className="home-social"
            variants={socialVar}
            initial="initial"
            animate="animate"
            exit="exit">
                <motion.div className="social-links" 
                variants={socialAnim}>
                    <MotionLink variants={socialBot} to="/contact" aria-label="link to contact">
                        <FontAwesomeIcon icon={faAt}/>
                    </MotionLink>
                    <motion.a href="https://www.linkedin.com/in/jimmywoooo/" target="_blank" variants={socialBot} aria-label="link to linkedin">
                        <FontAwesomeIcon icon={faLinkedin}/>
                    </motion.a>
                    <motion.a href="https://github.com/JimmyWoooo" target="_blank" variants={socialBot} aria-label="link to github">
                        <FontAwesomeIcon icon={faGithub}/>
                    </motion.a>
                    <motion.a href="https://www.youtube.com/channel/UCK0EZKzEQl8K81qdJkAj1zg" target="_blank" variants={socialBot} aria-label="link to youtube">
                        <FontAwesomeIcon icon={faYoutube}/>
                    </motion.a>
                </motion.div>
                <motion.div className="line"
                variants={socialLine}></motion.div>
            </motion.div>
            <motion.div className="home-heading-container"
            variants={homePage}
            initial="initial"
            animate="animate"
            exit="exit">
                <div className="home-heading">
                    <motion.span className="span1" 
                        variants={homeSpanRight}
                        initial="initial"
                        animate="animate">
                        {hello.map((letter, index) => {
                            return(
                                <HomeSpan  key={index} variant={null} className="newSpan">
                                    {letter === " " ? "\u00A0" : letter}
                                </HomeSpan>
                            )
                        })}
                    </motion.span>
                    <motion.span className="span2" variants={homeSpanLeft}>
                        {jimmy.map((letter, index) => {
                            return(
                                <HomeSpan key={index} variant={null} className="newSpan">
                                    {letter === " " ? "\u00A0" : letter}
                                </HomeSpan>
                            )
                        })}
                    </motion.span>
                    <motion.div className="span3" variants={homeSpanBot}>
                        {dev.map((letter, index) => {
                            return(
                                <HomeSpan key={index} variant={null} className="newSpan">
                                    {letter === " " ? "\u00A0" : letter}
                                </HomeSpan>
                            )
                        })}
                            <motion.div variants={artContainer} className="artContainer">
                            {artist.map((letter, index) => {
                                return(
                                    <HomeSpan key={index} variant={spanAnim} className="artSpan">
                                        {letter === " " ? "\u00A0" : letter}
                                    </HomeSpan>
                                )
                            })}
                        </motion.div>
                    </motion.div>
                    <motion.div className="home-button-project" variants={projectLinkContainer}>
                        <Link to="/projects" >
                            <button>View my work</button>
                        </Link>
                    </motion.div>
                </div>
            </motion.div>
        </motion.div>
    )
}

export default Home;